import type { ReactNode } from 'react';
import * as S from './LoginBackground.style';

const LoginBackground = ({ children }: { children: ReactNode }) => {
  return (
    <S.BackgroundImageContainer>
      <S.RedisLogo />
      {children}
    </S.BackgroundImageContainer>
  );
};

export default LoginBackground;
